/* tslint:disable */
/* eslint-disable */
/**
 * Authentication-API
 * This API allows strong authentication with LuxTrust.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticationSamlRequest,
  LightUserResponse,
  PostAuthenticationToken,
  PostUserRequest,
  TokenResponse,
  UpdateUserRequest,
} from '../models/index';
import {
    AuthenticationSamlRequestFromJSON,
    AuthenticationSamlRequestToJSON,
    LightUserResponseFromJSON,
    LightUserResponseToJSON,
    PostAuthenticationTokenFromJSON,
    PostAuthenticationTokenToJSON,
    PostUserRequestFromJSON,
    PostUserRequestToJSON,
    TokenResponseFromJSON,
    TokenResponseToJSON,
    UpdateUserRequestFromJSON,
    UpdateUserRequestToJSON,
} from '../models/index';

export interface AddAuthenticationRequest {
    postUserRequest: PostUserRequest;
}

export interface GetAuthenticationSamlRequestRequest {
    language?: string;
    tspId?: string;
}

export interface GetUserRequest {
    appUserUuid: string;
}

export interface PostAuthenticationSamlResponseRequest {
    sAMLResponse: string;
    relayState?: string;
}

export interface PostAuthenticationTokenRequest {
    postAuthenticationToken: PostAuthenticationToken;
}

export interface PostEmergencyLoginRequest {
    ssn: string;
    password: string;
}

export interface UpdateSsnRequest {
    appUserUuid: string;
    updateUserRequest: UpdateUserRequest;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Create an user
     * Create an user
     */
    async addAuthenticationRaw(requestParameters: AddAuthenticationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenResponse>> {
        if (requestParameters['postUserRequest'] == null) {
            throw new runtime.RequiredError(
                'postUserRequest',
                'Required parameter "postUserRequest" was null or undefined when calling addAuthentication().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostUserRequestToJSON(requestParameters['postUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenResponseFromJSON(jsonValue));
    }

    /**
     * Create an user
     * Create an user
     */
    async addAuthentication(requestParameters: AddAuthenticationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenResponse> {
        const response = await this.addAuthenticationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get authentication SAML request for LuxTrust
     * Get authentication SAML request for LuxTrust
     */
    async getAuthenticationSamlRequestRaw(requestParameters: GetAuthenticationSamlRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticationSamlRequest>> {
        const queryParameters: any = {};

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        if (requestParameters['tspId'] != null) {
            queryParameters['tsp_id'] = requestParameters['tspId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/saml-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticationSamlRequestFromJSON(jsonValue));
    }

    /**
     * Get authentication SAML request for LuxTrust
     * Get authentication SAML request for LuxTrust
     */
    async getAuthenticationSamlRequest(requestParameters: GetAuthenticationSamlRequestRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticationSamlRequest> {
        const response = await this.getAuthenticationSamlRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an user
     * get a user by his uuid
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LightUserResponse>> {
        if (requestParameters['appUserUuid'] == null) {
            throw new runtime.RequiredError(
                'appUserUuid',
                'Required parameter "appUserUuid" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{app_user_uuid}`.replace(`{${"app_user_uuid"}}`, encodeURIComponent(String(requestParameters['appUserUuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LightUserResponseFromJSON(jsonValue));
    }

    /**
     * Get an user
     * get a user by his uuid
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LightUserResponse> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Parse the SAML response generated by LuxTrust
     * Parse the SAML response generated by LuxTrust
     */
    async postAuthenticationSamlResponseRaw(requestParameters: PostAuthenticationSamlResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sAMLResponse'] == null) {
            throw new runtime.RequiredError(
                'sAMLResponse',
                'Required parameter "sAMLResponse" was null or undefined when calling postAuthenticationSamlResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['sAMLResponse'] != null) {
            formParams.append('SAMLResponse', requestParameters['sAMLResponse'] as any);
        }

        if (requestParameters['relayState'] != null) {
            formParams.append('RelayState', requestParameters['relayState'] as any);
        }

        const response = await this.request({
            path: `/saml-responses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Parse the SAML response generated by LuxTrust
     * Parse the SAML response generated by LuxTrust
     */
    async postAuthenticationSamlResponse(requestParameters: PostAuthenticationSamlResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postAuthenticationSamlResponseRaw(requestParameters, initOverrides);
    }

    /**
     * Exchange an Authorization Code or a Refresh Token for an id-token and new refresh-token
     * Exchange an Authorization Code or a Refresh Token for an id-token and new refresh-token
     */
    async postAuthenticationTokenRaw(requestParameters: PostAuthenticationTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenResponse>> {
        if (requestParameters['postAuthenticationToken'] == null) {
            throw new runtime.RequiredError(
                'postAuthenticationToken',
                'Required parameter "postAuthenticationToken" was null or undefined when calling postAuthenticationToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/tokens`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAuthenticationTokenToJSON(requestParameters['postAuthenticationToken']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenResponseFromJSON(jsonValue));
    }

    /**
     * Exchange an Authorization Code or a Refresh Token for an id-token and new refresh-token
     * Exchange an Authorization Code or a Refresh Token for an id-token and new refresh-token
     */
    async postAuthenticationToken(requestParameters: PostAuthenticationTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenResponse> {
        const response = await this.postAuthenticationTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Login with ssn and password
     * Login with ssn and password
     */
    async postEmergencyLoginRaw(requestParameters: PostEmergencyLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticationSamlRequest>> {
        if (requestParameters['ssn'] == null) {
            throw new runtime.RequiredError(
                'ssn',
                'Required parameter "ssn" was null or undefined when calling postEmergencyLogin().'
            );
        }

        if (requestParameters['password'] == null) {
            throw new runtime.RequiredError(
                'password',
                'Required parameter "password" was null or undefined when calling postEmergencyLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['ssn'] != null) {
            formParams.append('ssn', requestParameters['ssn'] as any);
        }

        if (requestParameters['password'] != null) {
            formParams.append('password', requestParameters['password'] as any);
        }

        const response = await this.request({
            path: `/emergency-login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticationSamlRequestFromJSON(jsonValue));
    }

    /**
     * Login with ssn and password
     * Login with ssn and password
     */
    async postEmergencyLogin(requestParameters: PostEmergencyLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticationSamlRequest> {
        const response = await this.postEmergencyLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an user
     * Update the SSN of a user
     */
    async updateSsnRaw(requestParameters: UpdateSsnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LightUserResponse>> {
        if (requestParameters['appUserUuid'] == null) {
            throw new runtime.RequiredError(
                'appUserUuid',
                'Required parameter "appUserUuid" was null or undefined when calling updateSsn().'
            );
        }

        if (requestParameters['updateUserRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserRequest',
                'Required parameter "updateUserRequest" was null or undefined when calling updateSsn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{app_user_uuid}`.replace(`{${"app_user_uuid"}}`, encodeURIComponent(String(requestParameters['appUserUuid']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LightUserResponseFromJSON(jsonValue));
    }

    /**
     * Update an user
     * Update the SSN of a user
     */
    async updateSsn(requestParameters: UpdateSsnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LightUserResponse> {
        const response = await this.updateSsnRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
